import { render, staticRenderFns } from "./cfa.vue?vue&type=template&id=9539d79c&scoped=true&"
import script from "./cfa.vue?vue&type=script&lang=js&"
export * from "./cfa.vue?vue&type=script&lang=js&"
import style0 from "./cfa.vue?vue&type=style&index=0&id=9539d79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9539d79c",
  null
  
)

export default component.exports